import styles from './index.less';
import { EyeO } from '@react-vant/icons';
import defaultInfoUrl2 from '@/assets/home/default_info2.png';
import { useRef, useState } from 'react';
import NoData from '@/components/NoData';
import { getWechatActivityList } from '@/service/banner';
import { Helmet, history, useModel } from '@umijs/max';
import dayjs from 'dayjs';
import { List, PullRefresh, Image } from 'react-vant';

const WechatActivity = () => {
  const [WechatActivityList, setWechatActivityList] = useState([]);
  const {defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );
  const pageNum = useRef(1);
  const [finished, setFinished] = useState<boolean>(false);

  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWechatActivityList([]);

    const data = await getWechatActivityList({
      pageNum: pageNum.current,
      pageSize: 10,
      communityId: defaultRoom?.communityId,
      status: '1'
    });
    const listData: any = [...WechatActivityList, ...data.rows];
    if (isRefresh || pageNum.current === 1) {
      setWechatActivityList(data.rows);
    } else {
      setWechatActivityList(listData);
    }

    if (
      data.rows.length === data.total ||
      data.rows.length < 10 ||
      !data.rows.length ||
      data.total === 0
    ) {
      // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1;
      setFinished(false); // 仍有数据可加载，保持为false
    }
  };

  const onRefresh = async () => {
    pageNum.current = 1;
    setFinished(true);
    setWechatActivityList([]);
    onLoadRefresh(true);
  };

  const click = (item: any) => {
    console.log(item);
    history.push(`/activityDetail?sequenceNbr=${item.sequenceNbr}`);
  };

  const formatStatus = (item: any) => {
    if (item.endFlag === '1') {
      return '已结束';
    } else {
      const startTime = dayjs(item.startTime);
      const endTime = dayjs(item.endTime);
      const currentTime = dayjs();
      const isAfterCurrentTime = currentTime.isAfter(endTime);
      const isBeforeCurrentTime = currentTime.isBefore(startTime);
      if (isBeforeCurrentTime) {
        return '未开始';
      }

      if (isAfterCurrentTime) {
        return '已结束';
      }

      if (!isAfterCurrentTime && !isBeforeCurrentTime) {
        return '进行中';
      }
    }
  };

  return (
    <div className={styles['wechatActivity']}>
      <Helmet>
        <title>社区活动</title>
      </Helmet>
      <div>
        <PullRefresh onRefresh={onRefresh}>
          <List
            finished={finished}
            onLoad={onLoadRefresh}
            finishedText="没有更多了"
          >
            {WechatActivityList?.length !== 0 ? (
              <>
                {WechatActivityList.map((item: any) => (
                  <div
                    onClick={() => click(item)}
                    className={styles['contentBox']}
                    key={item.sequenceNbr}
                  >
                    <div className={styles.content}>
                      {item.image ? (
                        <>
                          <Image
                            fit="cover"
                            width="100%"
                            src={item.image || defaultInfoUrl2}
                            height="115"
                            alt={item.title}
                          ></Image>
                        </>
                      ) : (
                        <>
                          <img src={defaultInfoUrl2} alt={item.title} />
                        </>
                      )}
                      <div
                        className={
                          formatStatus(item) === '已结束'
                            ? styles.statusEnd
                            : formatStatus(item) === '未开始'
                            ? styles.statusUnStart
                            : styles.statusIng
                        }
                      >
                        {formatStatus(item)}
                      </div>
                      <div className={styles.title}>{item.title}</div>
                      <div className={styles.box}>
                        <div className={styles['viewBox']}>
                          <div>{item.publishTime ? item.publishTime : '-'}</div>
                          <div className={styles.boxs}>
                            <EyeO className={styles.icon} />
                            {item.viewCount ? item.viewCount : 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <NoData />
            )}
          </List>
        </PullRefresh>
      </div>
    </div>
  );
};

export default WechatActivity;
